import React from 'react';

import PropTypes from 'prop-types';

import Toast from 'components/application/Toast';

import DivisionAccessDisallowed from 'components/toastMessages/messages/DivisionAccessDisallowed';
import ToastUpdateMessage from 'components/toastMessages/messages/ToastUpdateMessage';

const messageComponents = {
  divisionAccessDisallowed: DivisionAccessDisallowed,
  toastUpdateMessage: ToastUpdateMessage,
};

export default function GlobalToast({
  messageProps,
  messageType,
  onBurnToast,
  toastKey,
}) {
  const MessageComponent = messageComponents[messageType];

  return (
    <Toast
      burn={onBurnToast}
      burnTimer={messageType === 'divisionAccessDisallowed' ? 30000 : 5000}
      contents={<MessageComponent {...messageProps} />}
      modifiers='no-undo'
      toastKey={toastKey}
    />
  );
}

GlobalToast.propTypes = {
  messageType: PropTypes.string.isRequired,
  messageProps: PropTypes.object.isRequired,
  onBurnToast: PropTypes.func.isRequired,
};
